// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w-70 {
  width: 100px;
}

.w-400 {
  width: 400px;
}

.last_update_sticker_refresh {
  cursor: pointer;
}

.app_table_layout {
  padding: 0;
}

.w-180 {
  width: 180px;
}

.app_header_content {
  min-height: 0;
  margin-top: 0;
}

.customer_input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.selector_input {
  margin-left: -5px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

::ng-deep .ngx-datatable .datatable-body .datatable-row-detail {
  overflow-x: hidden;
  overflow-y: auto;
}

@media (max-width: 576px) {
  .isDesktop {
    display: none;
  }
}
@media (min-width: 768px) {
  .isMobile {
    display: none;
  }
}
@media (min-width: 992px) {
  .isMobile {
    display: none;
  }
}
@media (min-width: 1200px) {
  .isMobile {
    display: none;
  }
}
.w-200 {
  width: 200px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNlcC10YWJsZS5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFlBQUE7QUFDRjs7QUFFQTtFQUNFLFlBQUE7QUFDRjs7QUFFQTtFQUNFLGVBQUE7QUFDRjs7QUFFQTtFQUNFLFVBQUE7QUFDRjs7QUFFQTtFQUNFLFlBQUE7QUFDRjs7QUFHQTtFQUNFLGFBQUE7RUFDQSxhQUFBO0FBQUY7O0FBR0E7RUFDRSwwQkFBQTtFQUNBLDZCQUFBO0FBQUY7O0FBR0E7RUFDRSxpQkFBQTtFQUNBLHlCQUFBO0VBQ0EsNEJBQUE7QUFBRjs7QUFFQTtFQUNFLGtCQUFBO0VBQ0EsZ0JBQUE7QUFDRjs7QUFFQTtFQUNFO0lBQ0ksYUFBQTtFQUNKO0FBQ0Y7QUFFQTtFQUNFO0lBQ0ksYUFBQTtFQUFKO0FBQ0Y7QUFFQTtFQUNFO0lBQ0ksYUFBQTtFQUFKO0FBQ0Y7QUFHQTtFQUNFO0lBQ0ksYUFBQTtFQURKO0FBQ0Y7QUFLQTtFQUNFLFlBQUE7QUFIRiIsImZpbGUiOiJzZXAtdGFibGUuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIudy03MHtcbiAgd2lkdGg6IDEwMHB4O1xufVxuXG4udy00MDB7XG4gIHdpZHRoOiA0MDBweDtcbn1cblxuLmxhc3RfdXBkYXRlX3N0aWNrZXJfcmVmcmVzaHtcbiAgY3Vyc29yOiBwb2ludGVyO1xufVxuXG4uYXBwX3RhYmxlX2xheW91dHtcbiAgcGFkZGluZzogMDtcbn1cblxuLnctMTgwe1xuICB3aWR0aDogMTgwcHg7XG59XG5cblxuLmFwcF9oZWFkZXJfY29udGVudCB7XG4gIG1pbi1oZWlnaHQ6IDA7XG4gIG1hcmdpbi10b3A6IDA7XG59XG5cbi5jdXN0b21lcl9pbnB1dHtcbiAgYm9yZGVyLXRvcC1yaWdodC1yYWRpdXM6IDA7XG4gIGJvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOiAwO1xufVxuXG4uc2VsZWN0b3JfaW5wdXR7XG4gIG1hcmdpbi1sZWZ0OiAtNXB4O1xuICBib3JkZXItdG9wLWxlZnQtcmFkaXVzOiAwO1xuICBib3JkZXItYm90dG9tLWxlZnQtcmFkaXVzOiAwO1xufVxuOjpuZy1kZWVwIC5uZ3gtZGF0YXRhYmxlIC5kYXRhdGFibGUtYm9keSAuZGF0YXRhYmxlLXJvdy1kZXRhaWx7XG4gIG92ZXJmbG93LXg6IGhpZGRlbjtcbiAgb3ZlcmZsb3cteTogYXV0bztcbn1cblxuQG1lZGlhIChtYXgtd2lkdGg6IDU3NnB4KSB7XG4gIC5pc0Rlc2t0b3B7XG4gICAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbkBtZWRpYSAobWluLXdpZHRoOiA3NjhweCl7XG4gIC5pc01vYmlsZXtcbiAgICAgIGRpc3BsYXk6IG5vbmU7XG4gIH1cbn1cbkBtZWRpYSAobWluLXdpZHRoOiA5OTJweCkge1xuICAuaXNNb2JpbGV7XG4gICAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbkBtZWRpYSAobWluLXdpZHRoOiAxMjAwcHgpe1xuICAuaXNNb2JpbGV7XG4gICAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cblxuLnctMjAwe1xuICB3aWR0aDogMjAwcHg7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/containers/sep-dashboard/sep-table/sep-table.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAGA;EACE,aAAA;EACA,aAAA;AAAF;;AAGA;EACE,0BAAA;EACA,6BAAA;AAAF;;AAGA;EACE,iBAAA;EACA,yBAAA;EACA,4BAAA;AAAF;;AAEA;EACE,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE;IACI,aAAA;EACJ;AACF;AAEA;EACE;IACI,aAAA;EAAJ;AACF;AAEA;EACE;IACI,aAAA;EAAJ;AACF;AAGA;EACE;IACI,aAAA;EADJ;AACF;AAKA;EACE,YAAA;AAHF;AACA,44DAA44D","sourcesContent":[".w-70{\n  width: 100px;\n}\n\n.w-400{\n  width: 400px;\n}\n\n.last_update_sticker_refresh{\n  cursor: pointer;\n}\n\n.app_table_layout{\n  padding: 0;\n}\n\n.w-180{\n  width: 180px;\n}\n\n\n.app_header_content {\n  min-height: 0;\n  margin-top: 0;\n}\n\n.customer_input{\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.selector_input{\n  margin-left: -5px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n::ng-deep .ngx-datatable .datatable-body .datatable-row-detail{\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n@media (max-width: 576px) {\n  .isDesktop{\n      display: none;\n  }\n}\n\n@media (min-width: 768px){\n  .isMobile{\n      display: none;\n  }\n}\n@media (min-width: 992px) {\n  .isMobile{\n      display: none;\n  }\n}\n\n@media (min-width: 1200px){\n  .isMobile{\n      display: none;\n  }\n}\n\n\n.w-200{\n  width: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
